import { InterviewModel } from '../ts/interfaces/models/InterviewModel';
import { BaseService } from './baseService';

class InterviewService extends BaseService<InterviewModel> {
  controllerName = 'interviews';
}

export const interviewService = new InterviewService();
